if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaElements = Array.from(this.querySelectorAll('[data-media-id]'));
        if (!mediaElements.length) return;

        const openerMediaId = this.openedBy?.getAttribute('data-media-id');
        let activeMedia = openerMediaId
          ? mediaElements.find((element) => element.getAttribute('data-media-id') === openerMediaId)
          : null;

        if (!activeMedia) {
          activeMedia = mediaElements[0];
        }

        mediaElements.forEach((element) => {
          element.classList.toggle('active', element === activeMedia);
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (typeof activeMedia.scrollIntoView === 'function') {
          activeMedia.scrollIntoView({ block: 'center', inline: 'center' });
        }

        const container = this.querySelector('[role="document"]');
        if (container) {
          const mediaWidth = activeMedia.clientWidth || activeMedia.offsetWidth || 0;
          const targetScrollLeft = activeMedia.offsetLeft - (container.clientWidth - mediaWidth) / 2;
          container.scrollLeft = Math.max(0, targetScrollLeft);
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube') &&
          typeof activeMedia.loadContent === 'function'
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
